export const downloadFile = r => {
    const downloadUrl = window.URL.createObjectURL(new Blob([r.data]));
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', r.headers['fn']);
    document.body.appendChild(link);
    link.click();
    link.remove();
}